import { PureComponent } from 'react';
import cx from 'classnames';

import { getFeatureConfig } from '@luna/feature-config';

import { Iban } from '../iban/Iban';
import {
    getCZFormattedAccount,
    getFormattedAccount,
    getHUFormattedAccount,
    getRSFormattedAccount,
} from './AccountNoService';
import style from './AccountNumber.module.scss';

interface Account {
    number?: string;
    bankCode?: string;
    bic?: string;
    prefix?: string;
    iban?: string;
    countryCode?: string;
}

export interface Props {
    account: Account;
    className?: string;
}

export class AccountNumber extends PureComponent<Props> {
    renderCZAccountNo() {
        const { account } = this.props;
        const { number, iban } = getCZFormattedAccount(account);

        return [
            number && (
                <div key="account-number" data-cy="account-number-CZ">
                    {number}
                </div>
            ),
            iban && <Iban key="iban" iban={iban} />,
        ];
    }

    renderHUAccountNo() {
        const { account } = this.props;
        const { number, iban } = getHUFormattedAccount(account);

        return [
            number && (
                <div key="account-number" data-cy="account-number-HU">
                    {number}
                </div>
            ),
            iban && <Iban key="iban" iban={iban} />,
        ];
    }

    renderRSAccountNo() {
        const { account } = this.props;
        const { number, iban } = getRSFormattedAccount(account);

        return [
            number && (
                <div key="account-number" data-cy="account-number-RS">
                    {number}
                </div>
            ),
            iban && <Iban key="iban" iban={iban} />,
        ];
    }

    renderDefaultAccountNo() {
        const { account } = this.props;
        const { iban, number } = getFormattedAccount(account);

        if (iban) {
            return <Iban iban={iban} />;
        }

        if (number) {
            return <span data-cy="account-number-default">{number}</span>;
        }

        return null;
    }

    renderAccountNo() {
        const { country } = getFeatureConfig(({ base }) => base);

        if (country === 'CZ') {
            return this.renderCZAccountNo();
        }

        if (country === 'HU') {
            return this.renderHUAccountNo();
        }

        if (country === 'RS') {
            return this.renderRSAccountNo();
        }

        return this.renderDefaultAccountNo();
    }

    render() {
        return (
            <div className={cx(style.accountNumber, this.props.className)}>
                {this.renderAccountNo()}
            </div>
        );
    }
}
